export default __webpack_public_path__ + "static/media/4.ead22783.jpeg";